import { profileManager } from "./profile-manager.js";
import { DOMAIN_API_KEY } from './definitions.js';
import { initGigyaSDK } from './gigya-init.js';
import { RaissoError, errorFactory } from "./responses.js"

const SESSION_NAME = 'dismissAutoSignIn';

class AutoSignIn {
  silent = false;

  async tryLogin() {
    const isDismissed = this.storage() ? true : false;

    if (window.PasswordCredential && !isDismissed) {
      try {
        const cred = await navigator.credentials.get({
          mediation: this.silent ? 'silent' : 'optional'
        });
        if (cred?.type === "password" && (cred as unknown as PasswordCredential).password !== null) {
          const {id: mail, password} = cred as unknown as PasswordCredential;
          const initAutoSignInWorkflow = async () => {
            const profile = await profileManager.sendLogin(mail, password, DOMAIN_API_KEY);
            this.storage('REMOVE');
            return profile;
          };
          await new Promise<void>(resolve => {
            if (window.gigya) {
              resolve()
            } else {
              initGigyaSDK(document, window, () => { resolve() })
            }
          });
          return await initAutoSignInWorkflow()
        } else {
          this.storage('SET');
        }
      } catch (e) {
        console.error(e);
        if (e instanceof Error) throw e;
        if (e instanceof Response) {
          throw errorFactory(RaissoError, e.statusText, { context: { response: { statusText: e.statusText, body: (await e.clone().text() )} }})
        }
        throw errorFactory(RaissoError, 'Opps! Qualcosa è andato storto', { cause: e })
      }
    }
    return undefined;
  }

  async preventSilentLogin() {
    if (navigator.credentials?.preventSilentAccess) {
        await navigator.credentials.preventSilentAccess();
    }
    this.storage('SET');
  }

  storage(action?: "SET" | "REMOVE" | "GET") {
    let status: boolean;
    switch(action) {
      case 'SET':
        sessionStorage.setItem(SESSION_NAME, String(true));
        status = true
        break;
      case 'REMOVE':
        sessionStorage.removeItem(SESSION_NAME);
        status = true
        break;
      default: {
        const st = sessionStorage.getItem(SESSION_NAME);
        status = st === "true"
        break;
      }
    }
    return status;
  }
}

const autoSignIn = new AutoSignIn();

export {autoSignIn};
